import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 4V20L19 12L7 4Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
